<template>
  <div class="modalbox-content">
    <div class="section-label">Acesso por Canal</div>
    <div class="canais-grid">
      <div
        class="canal-card"
        :class="{ active: !!item.acessob2b }"
        @click="item.acessob2b = item.acessob2b ? 0 : 1"
      >
        <div class="canal-card__icon"><fa-icon icon="shopping-basket" /></div>
        <div class="canal-card__label">B2B</div>
        <div class="canal-card__check" :class="{ checked: !!item.acessob2b }">
          <CIcon v-if="!!item.acessob2b" name="cil-check" size="sm" />
        </div>
      </div>
      <div
        class="canal-card"
        :class="{ active: !!item.acessocallcenter }"
        @click="item.acessocallcenter = item.acessocallcenter ? 0 : 1"
      >
        <div class="canal-card__icon"><fa-icon icon="headset" /></div>
        <div class="canal-card__label">Call Center</div>
        <div class="canal-card__check" :class="{ checked: !!item.acessocallcenter }">
          <CIcon v-if="!!item.acessocallcenter" name="cil-check" size="sm" />
        </div>
      </div>
      <div
        class="canal-card"
        :class="{ active: !!item.acessofv }"
        @click="item.acessofv = item.acessofv ? 0 : 1"
      >
        <div class="canal-card__icon"><fa-icon icon="truck" /></div>
        <div class="canal-card__label">Força de Vendas</div>
        <div class="canal-card__check" :class="{ checked: !!item.acessofv }">
          <CIcon v-if="!!item.acessofv" name="cil-check" size="sm" />
        </div>
      </div>
    </div>

    <div class="section-label">Tributação</div>
    <div class="toggles-card">
      <div class="toggle-row">
        <span class="toggle-row__label">
          Calcula ST
          <BadgeErp campo="calcula_st" :camposSincronizados="camposSincronizados" />
        </span>
        <label class="toggle-switch">
          <input type="checkbox" :checked="!!item.calcula_st" @change="item.calcula_st = $event.target.checked ? 1 : 0" />
          <span class="toggle-slider"></span>
          <span class="toggle-text">{{ item.calcula_st ? 'Sim' : 'Não' }}</span>
        </label>
      </div>
      <div class="toggle-row">
        <span class="toggle-row__label">
          % IPI
          <BadgeErp campo="percipi" :camposSincronizados="camposSincronizados" />
        </span>
        <input type="number" step="0.01" class="form-control form-control-sm toggle-row__input" v-model="item.percipi" />
      </div>
      <div class="toggle-row">
        <span class="toggle-row__label">
          MVA Padrão
          <BadgeErp campo="mva_padrao" :camposSincronizados="camposSincronizados" />
        </span>
        <input type="number" step="0.01" class="form-control form-control-sm toggle-row__input" v-model="item.mva_padrao" />
      </div>
      <div class="toggle-row">
        <span class="toggle-row__label">
          Situação Tributária (CST)
          <BadgeErp campo="situacao_tributaria" :camposSincronizados="camposSincronizados" />
        </span>
        <input type="text" class="form-control form-control-sm toggle-row__input" v-model="item.situacao_tributaria" />
      </div>
    </div>
  </div>
</template>

<script>
import BadgeErp from "@/components/BadgeErp";

export default {
  name: "AcessoTributacao",
  components: { BadgeErp },
  props: {
    item: { type: Object, required: true },
    camposSincronizados: { type: Array, default: () => [] },
  },
};
</script>

<style scoped>
.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 12px 0 8px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.canais-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.canal-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  user-select: none;
}

.canal-card:hover {
  border-color: #c5c8cc;
  background-color: #fafafa;
}

.canal-card.active {
  border-color: #3a3e81;
  background-color: #eceaf3;
}

.canal-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #f2f2f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #3a3e81;
  font-size: 16px;
}

.canal-card.active .canal-card__icon {
  background-color: #dddce9;
}

.canal-card__label {
  font-size: 13px;
  font-weight: 600;
  color: #2c2c2c;
  flex: 1;
}

.canal-card__check {
  width: 18px;
  height: 18px;
  border: 2px solid #ccc;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.canal-card__check.checked {
  background-color: #3a3e81;
  border-color: #3a3e81;
  color: #fff;
}

.toggles-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 4px 16px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.toggle-row:last-child {
  border-bottom: none;
}

.toggle-row__label {
  font-size: 13px;
  color: #333;
}

.toggle-row__input {
  width: 200px !important;
  flex: 0 0 200px;
  text-align: right;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.toggle-switch input {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}

.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}

.toggle-text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}

</style>
